import { IPage } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export const selectPage = (state: IApplicationState): IPage => {
  return state.analytics.page;
};
